export const routes = {
  login: "/",
  home: "/home",
  perfil: "/player",
  team: "/players",
  playerHistory: "/player-history",
  files: "/files",
};
